/* eslint-disable */

import {NavigationItem} from "@lhacksrt/components";

export const defaultNavigation: NavigationItem[] = [
  {
    id: 'administration',
    title: 'sidebar.administration',
    type: 'group',
    icon: '',
    children: [
      {
        id: 'market-level-organization',
        title: 'sidebar.market-level-organization',
        type: 'basic',
        icon: 'heroicons_outline:building-library',
        link: '/market-level-organization',
      },
      {
        id: 'companies',
        title: 'sidebar.companies',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/companies',
      },
      {
        id: 'broker',
        title: 'sidebar.broker',
        type: 'basic',
        icon: 'heroicons_outline:building-storefront',
        link: '/brokers',
      },
      {
        id: 'apporteurs',
        title: 'sidebar.apporteurs',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/apporteurs/list',
      },
      {
        id: 'sous-apporteurs',
        title: 'sidebar.sous-apporteurs',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/sous-apporteurs/list',
      },
      {
        id: 'externals',
        title: 'sidebar.externals',
        type: 'collapsable',
        icon: 'heroicons_outline:shield-check',
        children: [
          {
            id: 'traffic-controllers',
            title: 'sidebar.traffic-controllers',
            type: 'basic',
            icon: 'heroicons_outline:shield-exclamation',
            link: '/externals/traffic-controllers',
          },
          {
            id: 'traffic-chiefs',
            title: 'sidebar.traffic-chiefs',
            type: 'basic',
            icon: 'heroicons_outline:star',
            link: '/externals/traffic-chiefs',
          },
          {
            id: 'traffic-agents',
            title: 'sidebar.traffic-agents',
            type: 'basic',
            icon: 'heroicons_outline:identification',
            link: '/externals/traffic-agents',
          }
        ]
      },
      {
        id: 'geographic',
        title: 'sidebar.geographic',
        type: 'basic',
        icon: 'heroicons_outline:map',
        link: '/geographic',
      }
    ]
  },
  {
    id: 'user-space',
    title: 'sidebar.user-space',
    type: 'group',
    icon: '',
    children: [
      {
        id: 'profile',
        title: 'sidebar.profile',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/profile',
      },
      {
        id: 'employees',
        title: 'sidebar.user',
        type: 'basic',
        icon: 'heroicons_outline:user',
        link: '/employees',
      },
      {
        id: 'external-users',
        title: 'sidebar.external-users',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/external-users',
      }
    ]
  },
  {
    id: 'pricing-group',
    title: 'sidebar.pricing',
    type: 'group',
    icon: '',
    children: [
      {
        id: 'indemnity-custom-tables',
        title: 'sidebar.indemnity-custom-tables',
        type: 'basic',
        icon: 'heroicons_outline:table',
        link: '/indemnity-custom-tables',
      }
    ]
  },
  {
    id: 'system-group',
    title: 'sidebar.system',
    type: 'group',
    icon: '',
    children: [
      {
        id: 'system',
        title: 'sidebar.system-management',
        type: 'basic',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/system',
      },
      {
        id: 'mlo-attestation-config',
        title: 'sidebar.mlo-attestation-config',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-check',
        link: '/mlo-attestation-config',
      }
    ]
  }
];

export const compactNavigation: NavigationItem[] = [
  {
    id: 'market-level-organization',
    title: 'sidebar.market-level-organization',
    type: 'basic',
    icon: 'heroicons_outline:building-library',
    link: '/market-level-organization',
  },
  {
    id: 'companies',
    title: 'sidebar.companies',
    type: 'basic',
    icon: 'heroicons_outline:building-office-2',
    link: '/companies',
  },
  {
    id: 'broker',
    title: 'sidebar.broker',
    type: 'basic',
    icon: 'heroicons_outline:building-storefront',
    link: '/brokers',
  },
  {
    id: 'apporteurs',
    title: 'sidebar.apporteurs',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/apporteurs/list',
  },
  {
    id: 'sous-apporteurs',
    title: 'sidebar.sous-apporteurs',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: '/sous-apporteurs/list',
  },
  {
    id: 'traffic-controllers',
    title: 'sidebar.traffic-controllers',
    type: 'basic',
    icon: 'heroicons_outline:shield-exclamation',
    link: '/externals/traffic-controllers',
  },
  {
    id: 'traffic-chiefs',
    title: 'sidebar.traffic-chiefs',
    type: 'basic',
    icon: 'heroicons_outline:star',
    link: '/externals/traffic-chiefs',
  },
  {
    id: 'traffic-agents',
    title: 'sidebar.traffic-agents',
    type: 'basic',
    icon: 'heroicons_outline:identification',
    link: '/externals/traffic-agents',
  },
  {
    id: 'geographic',
    title: 'sidebar.geographic',
    type: 'basic',
    icon: 'heroicons_outline:map',
    link: '/geographic',
  },
  {
    id: 'profile',
    title: 'sidebar.profile',
    type: 'basic',
    icon: 'heroicons_outline:identification',
    link: '/profile',
  },
  {
    id: 'employees',
    title: 'sidebar.user',
    type: 'basic',
    icon: 'heroicons_outline:user',
    link: '/employees',
  },
  {
    id: 'external-users',
    title: 'sidebar.external-users',
    type: 'basic',
    icon: 'heroicons_outline:user-circle',
    link: '/external-users',
  },
  {
    id: 'indemnity-custom-tables',
    title: 'sidebar.indemnity-custom-tables',
    type: 'basic',
    icon: 'heroicons_outline:table',
    link: '/indemnity-custom-tables',
  },
  {
    id: 'system',
    title: 'sidebar.system-management',
    type: 'basic',
    icon: 'heroicons_outline:cog-6-tooth',
    link: '/system',
  },
  {
    id: 'mlo-attestation-config',
    title: 'sidebar.mlo-attestation-config',
    type: 'basic',
    icon: 'heroicons_outline:clipboard-check',
    link: '/mlo-attestation-config',
  }
];
